import {DomainGraphType, ObjectType} from 'app-core/framework/CoreObjectConstants';
import {asCoreObject, getObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {assert} from 'Asserts';

type SchemaInterfaceType =
  | typeof DomainGraphType.CUSTOM_SCHEMA_INTERFACE
  | typeof DomainGraphType.STATIC_SCHEMA_INTERFACE;

export default function getSchemaInterfaceType(interfaceId: string): SchemaInterfaceType {
  const objectType = getObjectType(asCoreObject({id: interfaceId}));
  assert(
    (
      [DomainGraphType.CUSTOM_SCHEMA_INTERFACE, DomainGraphType.STATIC_SCHEMA_INTERFACE] as Array<ObjectType>
    ).includes(objectType),
    `Expected Custom or Static Schema Interface, not ${objectType}`
  );
  return objectType as SchemaInterfaceType;
}
